export default __webpack_public_path__ + "static/media/1387.c10cb4ec.png";